/**
 * 平台订制
 * $t('enum.E_PlatformCustoms.TrendAlarm')
 * $t('enum.E_PlatformCustoms.FaultDiagnosis')
 * $t('enum.E_PlatformCustoms.AiDiagnosis')
 * $t('enum.E_PlatformCustoms.SPOT_CHECK')
 * $t('enum.E_PlatformCustoms.Full')
 */
export enum E_PlatformCustoms {
    /**
     * 趋势报警
     */
    TrendAlarm = 'TrendAlarm',
    /**
     * 故障诊断
     */
    FaultDiagnosis = 'FaultDiagnosis',
    /**
     * Ai诊断
     */
    AiDiagnosis = 'AiDiagnosis',
    /**
     * 点巡检
     */
    SPOT_CHECK = 'SPOT_CHECK',
    /**
     * 全功能
     */
    Full = 'Full',
}

export const PlatformCustomMenuMap = {
    [E_PlatformCustoms.TrendAlarm]: [
        "business:large:screen",
        "business:online:monitor",
        "business:online:monitor",
        "business:eigenvalue:list",
        "system:fault:edit:check",
        "business:health:testing",
        "business:data:home",
        "business:week",
        "business:week:list",
        "business:week:history",
        "business:week:detail",
        "business:week:update",
        "business:week:down",
        "business:week:delete",
        "business:week2",
        "business:equipment:screen:list",
        "business:data:current:list",
        "business:data:history:list",
        "business:data:history:export",
        "business:data:history:faultTagLibrary",
        "alarmCenter:root",
        "alarmCenter:equipmentAlarm",
        "alarmCenter:equipmentAlarm:tempVibAlarm",
        "alarmCenter:sensorAlarm",
        "alarmCenter:sensorAlarm:batteryAlarm",
        "alarmCenter:sensorAlarm:angleAlarm",
        "alarmCenter:sensorAlarm:offlineAlarm",
        "alarmCenter:pushAlarm",
        "alarmCenter:pushAlarm:mailPush",
        "alarmCenter:pushAlarm:wechatPush",
        "business:wave:spectrum",
        "business:setting",
        "business:company:list",
        "business:company:save",
        "business:large:screen:addCompanyFile",
        "business:large:screen:addAreaFile",
        "business:large:screen:getCompanyCoordinates",
        "business:area:save",
        "business:company:remove",
        "business:devicemanager",
        "business:model:list",
        "business:model:save",
        "business:equipment:type:add",
        "business:model:remove",
        "business:equipment:list",
        "business:equipment:add",
        "business:equipment:listAll",
        "business:equipment:edit",
        "business:equipment:remove",
        "business:equipment:import",
        "business:new:sensor:list",
        "business:new:sensor:add",
        "business:new:sensor:edit",
        "business:new:sensor:unbindSensor",
        "business:new:sensor:delete",
        "business:new:sensor:bindSensor",
        "business:mapping:import",
        "business:mapping:bind:import",
        "business:hardwaremanagement",
        "business:gateway:list",
        "business:gateway:add",
        "business:gateway:edit",
        "business:gateway:remove",
        "business:sensor:list",
        "business:sensor:edit",
        "business:sensor:batchEdit",
        "business:sensor:import",
        "business:sensor:export",
        "business:sensor:add",
        "business:sensor:remove",
        "business:gateway:setting",
        "business:deviceLog:list",
        "business:thresholdManagement",
        "business:threshold:list",
        "business:threshold:save",
        "business:threshold:export",
        "business:threshold:import",
        "business:threshold:remove",
        "business:thresholdManagement:list",
        "business:thresholdManagement:sensorThresholdManagement",
        "business:equipmentRunThreshold:list",
        "system:home",
        "system:user:list",
        "system:user:add",
        "system:user:open:status",
        "business:authority:bind:list",
        "system:user:edit",
        "system:user:remove",
        "system:user:reset:pwd",
        "system:role:distribution:list",
        "system:user:wxinfo:list",
        "system:user:wxinfo:delete",
        "business:authority:list",
        "business:authority:add",
        "business:authority:update",
        "business:authority:detail",
        "business:authority:delete",
        "system:role:list",
        "system:role:add",
        "system:role:remove",
        "system:role:edit",
        "business:email:list",
        "business:email:add",
        "business:email:detail",
        "business:email:update",
        "business:email:delete"
    ],
    [E_PlatformCustoms.FaultDiagnosis]: [
        "business:large:screen",
        "business:online:monitor",
        "business:online:monitor",
        "business:eigenvalue:list",
        "system:fault:edit:check",
        "business:diagnosis:model:list",
        "business:diagnosis:model:handle",
        "business:data:fault_case_library",
        "business:health:testing",
        "business:data:home",
        "business:week",
        "business:week:list",
        "business:week:history",
        "business:week:detail",
        "business:week:update",
        "business:week:down",
        "business:week:delete",
        "business:week2",
        "business:equipment:screen:list",
        "business:data:current:list",
        "business:data:history:list",
        "business:data:history:export",
        "business:data:history:faultTagLibrary",
        "alarmCenter:root",
        "alarmCenter:equipmentAlarm",
        "alarmCenter:equipmentAlarm:tempVibAlarm",
        "alarmCenter:sensorAlarm",
        "alarmCenter:sensorAlarm:batteryAlarm",
        "alarmCenter:sensorAlarm:angleAlarm",
        "alarmCenter:sensorAlarm:offlineAlarm",
        "alarmCenter:pushAlarm",
        "alarmCenter:pushAlarm:mailPush",
        "alarmCenter:pushAlarm:wechatPush",
        "business:wave:spectrum",
        "business:setting",
        "business:company:list",
        "business:company:save",
        "business:large:screen:addCompanyFile",
        "business:large:screen:addAreaFile",
        "business:large:screen:getCompanyCoordinates",
        "business:area:save",
        "business:company:remove",
        "business:devicemanager",
        "business:model:list",
        "business:model:save",
        "business:equipment:type:add",
        "business:model:remove",
        "business:equipment:list",
        "business:equipment:add",
        "business:equipment:listAll",
        "business:equipment:edit",
        "business:equipment:remove",
        "business:equipment:import",
        "business:new:sensor:list",
        "business:new:sensor:add",
        "business:new:sensor:edit",
        "business:new:sensor:unbindSensor",
        "business:new:sensor:delete",
        "business:new:sensor:bindSensor",
        "business:mapping:import",
        "business:mapping:bind:import",
        "business:bear:list",
        "business:bear:save",
        "business:bear:remove",
        "business:hardwaremanagement",
        "business:gateway:list",
        "business:gateway:add",
        "business:gateway:edit",
        "business:gateway:remove",
        "business:sensor:list",
        "business:sensor:edit",
        "business:sensor:batchEdit",
        "business:sensor:import",
        "business:sensor:export",
        "business:sensor:add",
        "business:sensor:remove",
        "business:gateway:setting",
        "business:deviceLog:list",
        "business:thresholdManagement",
        "business:threshold:list",
        "business:threshold:save",
        "business:threshold:export",
        "business:threshold:import",
        "business:threshold:remove",
        "business:thresholdManagement:list",
        "business:thresholdManagement:sensorThresholdManagement",
        "business:equipmentRunThreshold:list",
        "system:home",
        "system:user:list",
        "system:user:add",
        "system:user:open:status",
        "business:authority:bind:list",
        "system:user:edit",
        "system:user:remove",
        "system:user:reset:pwd",
        "system:role:distribution:list",
        "system:user:wxinfo:list",
        "system:user:wxinfo:delete",
        "business:authority:list",
        "business:authority:add",
        "business:authority:update",
        "business:authority:detail",
        "business:authority:delete",
        "system:role:list",
        "system:role:add",
        "system:role:remove",
        "system:role:edit",
        "business:email:list",
        "business:email:add",
        "business:email:detail",
        "business:email:update",
        "business:email:delete",
        "business:alarm:home"
    ],
    [E_PlatformCustoms.AiDiagnosis]: [
        "business:large:screen",
        "business:online:monitor",
        "business:online:monitor",
        "business:eigenvalue:list",
        "system:fault:edit:check",
        "business:alarm:ai",
        "business:health:testing",
        "business:data:home",
        "business:week",
        "business:week:list",
        "business:week:history",
        "business:week:detail",
        "business:week:update",
        "business:week:down",
        "business:week:delete",
        "business:week2",
        "business:equipment:screen:list",
        "business:data:current:list",
        "business:data:history:list",
        "business:data:history:export",
        "business:data:history:faultTagLibrary",
        "alarmCenter:root",
        "alarmCenter:equipmentAlarm",
        "alarmCenter:equipmentAlarm:tempVibAlarm",
        "alarmCenter:sensorAlarm",
        "alarmCenter:sensorAlarm:batteryAlarm",
        "alarmCenter:sensorAlarm:angleAlarm",
        "alarmCenter:sensorAlarm:offlineAlarm",
        "alarmCenter:pushAlarm",
        "alarmCenter:pushAlarm:mailPush",
        "alarmCenter:pushAlarm:wechatPush",
        "business:wave:spectrum",
        "business:setting",
        "business:company:list",
        "business:company:save",
        "business:large:screen:addCompanyFile",
        "business:large:screen:addAreaFile",
        "business:large:screen:getCompanyCoordinates",
        "business:area:save",
        "business:company:remove",
        "business:devicemanager",
        "business:model:list",
        "business:model:save",
        "business:equipment:type:add",
        "business:model:remove",
        "business:equipment:list",
        "business:equipment:add",
        "business:equipment:listAll",
        "business:equipment:edit",
        "business:equipment:remove",
        "business:equipment:import",
        "business:new:sensor:list",
        "business:new:sensor:add",
        "business:new:sensor:edit",
        "business:new:sensor:unbindSensor",
        "business:new:sensor:delete",
        "business:new:sensor:aiparams",
        "business:new:sensor:bindSensor",
        "business:mapping:import",
        "business:mapping:bind:import",
        "business:bear:list",
        "business:bear:save",
        "business:bear:remove",
        "business:hardwaremanagement",
        "business:gateway:list",
        "business:gateway:add",
        "business:gateway:edit",
        "business:gateway:remove",
        "business:sensor:list",
        "business:sensor:edit",
        "business:sensor:batchEdit",
        "business:sensor:import",
        "business:sensor:export",
        "business:sensor:add",
        "business:sensor:remove",
        "business:gateway:setting",
        "business:deviceLog:list",
        "business:thresholdManagement",
        "business:threshold:list",
        "business:threshold:save",
        "business:threshold:export",
        "business:threshold:import",
        "business:threshold:remove",
        "business:thresholdManagement:list",
        "business:thresholdManagement:sensorThresholdManagement",
        "business:equipmentRunThreshold:list",
        "system:home",
        "system:user:list",
        "system:user:add",
        "system:user:open:status",
        "business:authority:bind:list",
        "system:user:edit",
        "system:user:remove",
        "system:user:reset:pwd",
        "system:role:distribution:list",
        "system:user:wxinfo:list",
        "system:user:wxinfo:delete",
        "business:authority:list",
        "business:authority:add",
        "business:authority:update",
        "business:authority:detail",
        "business:authority:delete",
        "system:role:list",
        "system:role:add",
        "system:role:remove",
        "system:role:edit",
        "business:email:list",
        "business:email:add",
        "business:email:detail",
        "business:email:update",
        "business:email:delete",
        "system:aiHelper",
        "business:alarm:home"
    ],
    [E_PlatformCustoms.SPOT_CHECK]: [
        "business:diagnosis:model:list",
        "business:diagnosis:model:handle",
        "business:inspection",
        "business:task:list",
        "business:danger:list",
        "business:upkeep:list",
        "business:repair:list",
        "business:inspection:week:list",
        "business:inspection:week:history",
        "business:inspection:week:update",
        "business:inspection:week:down",
        "business:inspection:week:delete",
        "business:inspection:config",
        "business:inspection:area",
        "business:point:list",
        "business:standard:list",
        "business:line:list",
        "business:taskPlan:list",
        "business:group:list",
        "business:inspect:library",
        "business:danger:lib:list",
        "business:repair:lib:list",
        "business:upkeep:lib:list",
        "business:instantInspection:list",
        "business:setting",
        "business:company:list",
        "business:company:save",
        "business:large:screen:addCompanyFile",
        "business:large:screen:addAreaFile",
        "business:large:screen:getCompanyCoordinates",
        "business:area:save",
        "business:company:remove",
        "business:devicemanager",
        "business:model:list",
        "business:model:save",
        "business:equipment:type:add",
        "business:model:remove",
        "business:equipment:list",
        "business:equipment:add",
        "business:equipment:listAll",
        "business:equipment:edit",
        "business:equipment:remove",
        "business:equipment:import",
        "business:new:sensor:list",
        "business:new:sensor:add",
        "business:new:sensor:edit",
        "business:new:sensor:unbindSensor",
        "business:new:sensor:delete",
        "business:new:sensor:bindSensor",
        "business:mapping:import",
        "business:mapping:bind:import",
        "business:bear:list",
        "business:bear:save",
        "business:bear:remove",
        "system:home",
        "system:user:list",
        "system:user:add",
        "system:user:open:status",
        "business:authority:bind:list",
        "system:user:edit",
        "system:user:remove",
        "system:user:reset:pwd",
        "system:role:distribution:list",
        "system:user:wxinfo:list",
        "system:user:wxinfo:delete",
        "business:authority:list",
        "business:authority:add",
        "business:authority:update",
        "business:authority:detail",
        "business:authority:delete",
        "system:role:list",
        "system:role:add",
        "system:role:remove",
        "system:role:edit",
        "business:alarm:home"
    ]
}

export function getCustomPlatformMenu(custom: E_PlatformCustoms): Set<string> {
    return new Set(PlatformCustomMenuMap[custom])
}
